import { gql } from '@apollo/client';

export const SEARCH_SCHOOLS = gql`
  query schools($query: String!) {
    schools(query: $query) {
      id
      name
      imageUrl
      emailDomain
      username
    }
  }
`;
